export interface ResultRecord {
  score: number;
  lifeExpectancy: number;
  title: string;
  percentile: number;
  date: string;
}

const MAX_RECORDS = 10;

function getStorageKey(quizId?: string): string {
  if (quizId) return `quiz_history_${quizId}`;
  return 'lifeExpectancy_history';
}

export function saveResult(record: ResultRecord, quizId?: string): void {
  const history = getHistory(quizId);
  history.unshift(record);
  if (history.length > MAX_RECORDS) {
    history.pop();
  }
  localStorage.setItem(getStorageKey(quizId), JSON.stringify(history));
}

export function getHistory(quizId?: string): ResultRecord[] {
  try {
    const data = localStorage.getItem(getStorageKey(quizId));
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export function getChangeMessage(current: ResultRecord, quizId?: string, unit: string = '살'): string | null {
  const history = getHistory(quizId);
  if (history.length < 2) return null;

  const previous = history[1];
  const diff = current.lifeExpectancy - previous.lifeExpectancy;

  if (diff > 0) {
    return `이전보다 ${diff}${unit} 올랐어요! 🎉`;
  } else if (diff < 0) {
    return `이전보다 ${Math.abs(diff)}${unit} 내려갔어요. 건강 관리에 신경 쓰세요!`;
  } else {
    return '이전과 같은 결과예요. 꾸준히 유지하고 계시네요!';
  }
}

export function hasCompletedQuiz(quizId: string): boolean {
  return getHistory(quizId).length > 0;
}

export function getCompletedQuizIds(): string[] {
  const ids: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith('quiz_history_')) {
      ids.push(key.replace('quiz_history_', ''));
    }
  }
  return ids;
}
